var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c('b-badge',{class:_vm.environmentName,attrs:{"pill":""}},[_vm._v(_vm._s(_vm.environmentDisplayName))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }